export const CONDITIONS = {
  PREGNANCY: 'pregnancy',
  POSTPARTUM: 'postpartum',
  INCONTINENCE: 'incontinence',
  SEXUAL: 'sexual',
};

export const ONBOARDING_STATUS = {
  WELCOME: 'welcome',
  SURVEY: 'survey',
  SIGN_UP: 'signUp',
  PLANS: 'plans',
  THANKYOU: 'thankyou',
  TEST_RESULTS: 'testResults',
};

export const KEYS = {
  PATH: 'path',
  CONDITIONS: 'conditions',
  USER_NAME: 'userName',
  ONBOARDING_STATUS: 'onboardingStatus',
  CONTENT: 'content',
  USER_TOKEN: 'userToken',
  USER_ID: 'userId',
  SOURCE: 'source',
  IDENTIFIER: 'identifier',
  URL_PARAMS: 'urlParams',
  USER_EMAIL: 'userEmail',
  PARTNER: 'partner',
  IS_NATIVE: 'isNative',
  FLOW: 'flow',
  FIRST_TOUCH_UTM: 'first_touch_utm',
};

export const IDENTIFIERS = {
  FULL: 'evie-program',
  THIRTY: 'evie-program-discount',
  US: 'evie-program-usa',
  US_DISCOUNT: 'evie-program-usa-discount',
  FIFTY: 'evie-program-discount-50',
  TWENTY: 'evie-program-discount-20',
  PELVIC: 'evie-program-serpelvica',
  FREE_MONTH: 'evie-program-free-month',
};

export const USER_ROLES = {
  INDIVIDUAL: 'individual',
  PARTNER: 'partner',
};

export const DISCOUNTS = {
  [IDENTIFIERS.THIRTY]: 70,
  [IDENTIFIERS.FIFTY]: 50,
  [IDENTIFIERS.US_DISCOUNT]: 70,
  [IDENTIFIERS.TWENTY]: 80,
  [IDENTIFIERS.PELVIC]: 62.4,
};
